{
  "certification-round-plan": {
    "eyebrow": "자격증 회독 가이드",
    "title": "회독 계획은 시간보다 범위로 만드세요",
    "summary": "시험일까지 남은 날만 세면 밀렸을 때 계획이 무너집니다. 과목별 실제 분량과 이미 끝낸 범위를 먼저 고정해야 다시 계산할 수 있어요.",
    "steps": [
      [
        "시험일을 고정해요",
        "접수일과 시험일을 구분하고 실제 응시할 회차를 기준으로 남은 날짜를 셉니다."
      ],
      [
        "교재 분량을 단위로 적어요",
        "페이지·강의·문제처럼 끝을 확인할 수 있는 단위로 과목별 총량을 입력합니다."
      ],
      [
        "공부한 범위를 남겨요",
        "시간만 재지 않고 1–25쪽처럼 범위를 기록하면 겹쳐 공부한 구간을 중복 계산하지 않을 수 있습니다."
      ],
      [
        "밀린 날은 남은 범위만 다시 나눠요",
        "완료 기록을 지우지 않고 남은 일정만 재계산해야 실제 진도가 보존됩니다."
      ]
    ],
    "cta": "내 시험과 과목 만들기",
    "seoTitle": "자격증 회독 계획표를 만드는 법",
    "seoDescription": "시험일까지 남은 교재 분량을 범위로 나누고, 겹친 기록을 중복 계산하지 않는 자격증 회독 계획 방법을 알아보세요."
  },
  "wrong-note-review": {
    "eyebrow": "오답 복습 가이드",
    "title": "오답은 모으는 것보다 다시 나타나게 해야 해요",
    "summary": "오답노트가 쌓이기만 하면 시험 직전 다시 찾기 어렵습니다. 본 날을 기준으로 2주·4주·8주 간격의 다음 복습일을 만들어 두세요.",
    "steps": [
      [
        "틀린 이유를 짧게 남겨요",
        "문제 전체를 옮기기보다 다시 틀릴 이유와 확인할 개념을 한 문장으로 적습니다."
      ],
      [
        "2주 뒤 처음 다시 봐요",
        "처음부터 너무 자주 알림을 만들지 않고, 기억이 흐려질 때 첫 복습을 시작합니다."
      ],
      [
        "복습한 날부터 4주·8주를 다시 세요",
        "예정일을 놓쳐도 자동으로 완료 처리하지 않고 실제로 다시 본 날을 다음 기준으로 삼습니다."
      ],
      [
        "설명할 수 있을 때 정복해요",
        "정복 처리한 오답도 필요하면 다시 학습 상태로 되돌릴 수 있어야 합니다."
      ]
    ],
    "cta": "내 오답 복습 시작하기",
    "seoTitle": "오답노트 2·4·8주 복습 주기",
    "seoDescription": "틀린 문제를 저장한 뒤 2주, 4주, 8주 간격으로 다시 확인하는 오답 복습 흐름과 밀린 복습 처리 원칙을 설명합니다."
  },
  "working-adult-study-log": {
    "eyebrow": "직장인 수험 기록 가이드",
    "title": "짧게 공부한 날도 다음 범위가 남아야 해요",
    "summary": "퇴근 후 공부는 매일 같은 시간을 확보하기 어렵습니다. 계획한 시간보다 실제로 끝낸 과목·회독·범위를 남기면 다음 시작점이 분명해집니다.",
    "steps": [
      [
        "기록은 공부 직후 끝내요",
        "과목과 범위는 필수로, 시간과 메모는 필요할 때만 적어 입력 부담을 줄입니다."
      ],
      [
        "다음 범위를 자동으로 이어가요",
        "마지막 범위의 다음 단위를 제안하되 저장하기 전에는 언제든 수정할 수 있어야 합니다."
      ],
      [
        "시간 없는 기록도 활동으로 인정해요",
        "공부 시간을 입력하지 않았다고 0분으로 왜곡하지 않고 기록일과 범위는 그대로 남깁니다."
      ],
      [
        "완료된 주끼리 비교해요",
        "진행 중인 이번 주와 지난주를 섞지 않고, 끝난 7일 단위끼리만 비교합니다."
      ]
    ],
    "cta": "오늘 공부 기록 만들기",
    "seoTitle": "직장인 자격증 공부 기록법",
    "seoDescription": "출퇴근과 퇴근 후 공부를 시간 추정 대신 실제 과목·회독·범위로 짧게 기록하고 다음 행동으로 잇는 방법입니다."
  }
}
